import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import BZAPIService from '../../services/BZAPIService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardBody, Col, Row, Collapse, List } from 'reactstrap';
import Background from '../common/Background';
import { Link } from 'react-router-dom';

const getContentClassNames = color => {
  const contentClassNames = 'display-12 fs-12 mb-12 font-weight-normal text-sans-serif';
  return contentClassNames;
};

const CardSummary = ({ title, rate, linkText, to, color, children, message, timestamp, errors }) => {
  let icon = 'exclamation';
  switch (color) {
    case 'green':
      icon = 'check';

      break;
    case 'light-blue':
      icon = 'clock';

      break;
    case 'blue':
      icon = 'exclamation';

      break;

    default:
      break;
  }

  const [active, setActive] = useState('');
  const [isServiceActive, setIsServiceActive] = useState(true);

  const errorCodes = [
    {
      id: 'H001',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H001---Vendor-API-Request-Error'
    },
    {
      id: 'H002',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H002---Vendor-API-Auth-Token-Generation-Error'
    },
    {
      id: 'H003',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H003---Vendor-API-Error'
    },
    {
      id: 'H004',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H004---Vendor-API-Error'
    },
    {
      id: 'H005',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H005---Vendor-Public-API-Error'
    },
    {
      id: 'H006',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H006---Vendor-API-Error-Threshold-Exceeded'
    },
    {
      id: 'OP001',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP001---Integration-Not-Configured'
    },
    {
      id: 'OP002',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP002---Vendor-Integration-Disabled'
    },
    {
      id: 'OP003',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP003---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP004',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP004---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP005',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP005---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP006',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP006---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP007',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP007---Incompatible-ServiceNow-CI'
    },
    {
      id: 'OP008',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP008---ServiceNow-API-Request-Error'
    },
    {
      id: 'OP009',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP009---Vendor-Cloud-Health-Error'
    },
    {
      id: 'OP010',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP010---Vendor-Cloud-Inventory-Access-Error'
    },
    {
      id: 'OP011',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP011---Vendor-Subscription-Enrollment-Error'
    },
    {
      id: 'OP012',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP012---ServiceNow-Connection-Error'
    },
    {
      id: 'P001',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-bugzero-api-errors#P001---BugZero-API-Error'
    },
    {
      id: 'P002',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-bugzero-api-errors#P002---BugZero-API-Error'
    }
  ];

  async function getStatus() {
    try {
      const res = await BZAPIService.getStatus(to);
      // console.log('bug service, ', res?.data?.enabled);
      setIsServiceActive(res?.data?.enabled === 1 ? true : false);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    getStatus();
  }, []);

  const toggleErrors = (e, to) => {
    e.preventDefault();
    active === to ? setActive('') : setActive(to);
  };
  return (
    <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
      <Background className={`bg-card`} />
      <CardBody className="position-relative">
        <Row>
          <Col>
            <h6 className="dash-vendor-label">{children.replace('Bug Service', '')}</h6>
          </Col>
          <Col className="text-right d-inline-flex justify-content-end">
            <p className="small">
              <span className="fa-stack fa-xs mr-1">
                <FontAwesomeIcon icon="circle" className={`branding-${color} fa-stack-2x`} />
                <FontAwesomeIcon icon={icon} className="fa-stack-1x" inverse />
              </span>
            </p>
            <p className={`branding-${color} small`}>
              <span className="pb-2">{title}</span>
            </p>
            {/*
            {isServiceActive ? (
              <></>
            ) : (
              <div className="d-inline-flex ml-2">
                <p className="small">
                  <span className="fa-stack fa-xs mr-1">
                    <FontAwesomeIcon icon="circle" className={`branding-red fa-stack-2x`} />
                    <FontAwesomeIcon icon="exclamation" className="fa-stack-1x" inverse />
                  </span>
                </p>
                <p className="small">
                  {' '}
                  <span className="pb-2">DISABLED</span>
                </p>
              </div>
            )} */}
          </Col>
        </Row>

        <div className={getContentClassNames(color)}>
          {title === 'NOT CONFIGURED' ? (
            <div className="col" data-testid={to + '-not-configured'}>
              <div className="row">
                <Link to={`/vendors/${to}/configuration`}>
                  <Button
                    color="falcon-default"
                    className="btn btn-falcon-default mt-2"
                    size="sm"
                    data-testid={to + '-setup-btn'}
                  >
                    Configure
                  </Button>
                </Link>
              </div>
            </div>
          ) : (
            <>
              {title === 'RUNNING' ? (
                <p>
                  Service started{' '}
                  {timestamp
                    ? moment
                        .utc(timestamp)
                        .local()
                        .fromNow()
                    : 'Pending...'}
                  .
                </p>
              ) : (
                <></>
              )}
              <div data-testid={to + '-message'}>{message === 'service started' ? '' : message}</div>
              {errors?.length ? (
                <div className="active mt-2">
                  {active === to ? <FontAwesomeIcon icon={'caret-down'} /> : <FontAwesomeIcon icon={'caret-right'} />}
                  <a
                    href="/"
                    className="nav-link-text active ml-1"
                    onClick={e => toggleErrors(e, to)}
                    style={{ marginBottom: '1rem' }}
                  >
                    more info
                  </a>
                  {/* <Collapse isOpen={e.label === active ? true : false}> */}

                  <Collapse isOpen={active === to ? true : false}>
                    <List type="unstyled" data-testid={to + '-error-list'}>
                      {errors.map(e => (
                        <li key={e.label}>
                          <a
                            href={`${
                              errorCodes.find(err => err.id.toLowerCase() === e.label.toLowerCase()) !== undefined
                                ? errorCodes.find(err => err.id.toLowerCase() === e.label.toLowerCase())?.href
                                : '/documentation/user-guides/bugzero-dashboard-error-codes'
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <small className="active">
                              {e.label} - {e.value}
                            </small>
                          </a>
                        </li>
                      ))}
                    </List>
                  </Collapse>
                </div>
              ) : (
                ''
              )}
            </>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

CardSummary.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  rate: PropTypes.string,
  linkText: PropTypes.string,
  to: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  errors: PropTypes.array,
  timestamp: PropTypes.string
};

export default CardSummary;
